/*
 * @Author: gaobin
 * @Date: 2024-10-09 16:00:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-19 13:56:01
 * @Description: 登录接口
 */
const userMap = {
  // 用户登录
  userToLoginExt: '/usb/uwb-app/api/v1/hello/user/login/login',
  // 获取用户信息
  getUserInfoExt: '/usb/uwb-app/api/v1/user/userInfo',

  // 用户浏览历史统计
  getHistoryCountExt: '/usb/uwb-app/api/v1/share/historyCount',

  // 用户收藏统计
  getCollectCountExt: '/usb/uwb-app/api/v1/share/collectCount',

  // 更新头像
  updateAvatarExt: '/usb/uwb-app/api/v1/user/updateAvatar',
};

export default userMap;
